import { FE_FAIRE_DIRECT_SIGNUP_MODAL_REFRESH_250110 } from "@faire/retailer-settings/FE_FAIRE_DIRECT_SIGNUP_MODAL_REFRESH_250110";

import { isFaireDirectVariant } from "@faire/retailer/components/AppSignUp/AppSignUpModalVariant";
import { useAppSignUpState } from "@faire/retailer/components/AppSignUp/useAppSignUpState";

import { useAssignSetting, useSetting } from "./__internal__/useSetting";

export const useSettingFaireDirectSignupModalRefresh = (): boolean => {
  const { modalVariant } = useAppSignUpState();
  const setting = useSetting(FE_FAIRE_DIRECT_SIGNUP_MODAL_REFRESH_250110);

  return isFaireDirectVariant(modalVariant) && setting;
};

export const useAssignSettingFaireDirectSignupModalRefresh = () =>
  useAssignSetting(FE_FAIRE_DIRECT_SIGNUP_MODAL_REFRESH_250110);
